import { API_ROUTES } from "../utils/constants"
import apiHelper from "./apiHelper"

const pathBase = API_ROUTES.SETTINGS.RADIO

export function addRadio(data) {
    return apiHelper({ method: "post", path: pathBase.ADD, data })
}

export function editRadio(data) {
    return apiHelper({ method: "post", path: pathBase.EDIT, data })
}

export function deleteRadio(radioId) {
    return apiHelper({ method: "delete", path: pathBase.DELETE, data: { radioId } })
}

export function getRadioList() {
    return apiHelper({ method: "get", path: pathBase.GET_ALL })
}
